var exports = {
  "FK": "milestone__qPpaRb",
  "wx": "header__2sH-_F",
  "zD": "titleLink__ov7C4Y",
  "gr": "titleIcon__DH-q5y",
  "oV": "closedBadge__Y64IcV",
};

module.exports = exports;
